import { render, staticRenderFns } from "./page-loading.vue?vue&type=template&id=67de1083&scoped=true&"
import script from "./page-loading.vue?vue&type=script&lang=js&"
export * from "./page-loading.vue?vue&type=script&lang=js&"
import style0 from "./page-loading.vue?vue&type=style&index=0&id=67de1083&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67de1083",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
